export default __webpack_public_path__ + "static/media/icons.7da204f5.svg";